/**
 * HTML Utilities
 *
 * Pure utility functions for HTML string manipulation.
 */

/**
 * Inserts an asterisk into HTML for required form fields
 * @param htmlString - The HTML string
 * @param required - Whether the field is required
 * @returns The modified HTML string
 */
export const insertAsterisk = (
	htmlString: string,
	required: boolean
): string => {
	if (required) {
		const pattern = /(?:<\/\w+>)(?![\s\S]*<\/\w+>)/g // regex pattern to find the last closing tag inside the HTML string
		return htmlString.replace(
			pattern,
			`<span class="gigya-required-display gigya-reset" style="color:#ce4635;padding: 0 5px;">*</span>$&`
		)
	}
	return htmlString
}
